const getters = {
  token: state => state.user.token,
  roles: state => state.user.roles,
  authStatus: state => state.user.authStatus,
  name: state => state.user.name,
  dialogBindPhone: state => state.user.dialogBindPhone,
  userInfo: state => state.user.userInfo,
  companyInfo: state => state.user.companyInfo,
  userType: state => state.user.userType
}
export default getters
